import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";
import { MdAddPhotoAlternate } from "react-icons/md";
import Preloader from "../PreloaderGrids/Preloader";
import logo from "../../assets/logo.png"

import "../Icones/icones.scss"

const importAllIcons = (r) =>
  r.keys().map((file) => ({
    name: file.replace("./", "").replace(".png", ""),
    src: r(file),
  }));

const icons = importAllIcons(
  require.context("../../assets/iconesAlteracao", false, /\.png$/)
);

function Icones() {
  const [marcadores, setMarcadores] = useState([]);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItens, setTotalItens] = useState(0);

  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingPage, setLoadingPage] = useState(false);

  const navigate = useNavigate();

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  // ================= TOTAL + PAGINAS =================
  useEffect(() => {
    async function fetchTotal() {
      const { data } = await api.get(
        `/totalequipamentos?searchTerm=${searchTerm}`,
        { headers: { typo: localStorage.getItem("id") } }
      );

      setTotalItens(data.result);

      const totalPages = Math.ceil(data.result / limit);
      setPages(Array.from({ length: totalPages }, (_, i) => i + 1));
    }

    fetchTotal();
  }, [limit, searchTerm]);

  // ================= DADOS =================
  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      const start = Date.now();
      const MIN_DELAY = 2500;

      try {
        const { data } = await api.get(
          `/equipamentospages?limit=${limit}&page=${currentPage}&searchTerm=${searchTerm}`,
          { headers: { typo: localStorage.getItem("id") } }
        );

        if (mounted) {
          setMarcadores(data?.equipamentos?.data || []);
        }
      } catch (err) {
        if (mounted) setMarcadores([]);
      } finally {
        const elapsed = Date.now() - start;

        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        if (mounted) {
          setLoading(false);
          setShowLoader(false);
          setLoadingPage(false);
        }
      }
    }

    fetchData();
    return () => (mounted = false);
  }, [currentPage, limit, searchTerm]);

  // ================= PAGINAÇÃO =================
  const handlePagination = (page) => {
    if (page === currentPage) return;
    if (page >= 1 && page <= pages.length) {
      setLoadingPage(true);
      setCurrentPage(page);
    }
  };

  const handleLimitChange = useCallback((e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1);
  }, []);

  function getVisiblePages(currentPage, totalPages) {
    if (totalPages <= 3) return Array.from({ length: totalPages }, (_, i) => i + 1);

    if (currentPage <= 2) return [1, 2, "...", totalPages];
    if (currentPage >= totalPages - 1) return [1, "...", totalPages - 1, totalPages];

    return [1, "...", currentPage, "...", totalPages];
  }

  // ================= ALTERAR ÍCONE =================
  //CONFIRMAÇÃO DE ALTERAÇÃO DE ICONE
  const handleChangeIcon = async (item) => {
    // =========================================================
    // CONFIRMAÇÃO INICIAL
    // =========================================================

    
const confirm = await Swal.fire({
  title: "Alterar ícone do veículo",

  background: "#102333",
  width: "430px",
  padding: "26px",


html: `
  <div class="vehicle-confirm">

    <div class="vehicle-confirm-preview">
      <img
        src="/icones/${encodeURIComponent(item.icone)}.png?v=${encodeURIComponent(item.icone)}"
        alt="Ícone atual do veículo ${String(item.placa || "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")}"
        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
      />

      <div class="vehicle-confirm-preview-fallback" style="display:none;">
        <span>Ícone indisponível</span>
      </div>
    </div>

    <p class="vehicle-confirm-description">
      Este é o ícone atualmente associado ao veículo.
    </p>

    <div class="vehicle-confirm-plate">
      <span class="vehicle-confirm-label">VEÍCULO SELECIONADO</span>
      <strong>${String(item.placa || "Sem placa")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")}</strong>
    </div>

    <p class="vehicle-confirm-hint">
      Deseja realmente alterar o ícone deste veículo?
    </p>

  </div>
`,

  showCancelButton: true,
  confirmButtonText: "Confirmar alteração",
  cancelButtonText: "Cancelar",

  customClass: {
    popup: "swal-system vehicle-confirm-popup",
    title: "vehicle-confirm-title",
    htmlContainer: "vehicle-confirm-html",
    confirmButton: "swal-system-confirm vehicle-confirm-action",
    cancelButton: "swal-system-cancel vehicle-cancel-action",
    actions: "vehicle-confirm-actions",
  },

  buttonsStyling: false,
  reverseButtons: true,
  focusCancel: true,
  allowOutsideClick: false,
  allowEscapeKey: true,
});


    if (!confirm.isConfirmed) return;

    // =========================================================
    // LOADER
    // =========================================================

 
await Swal.fire({
  title: "Preparando edição",
  background: "#102333",
  color: "#edf5fa",
  width: "360px",
  padding: "28px 26px 25px",

  showConfirmButton: false,
  showCloseButton: false,
  allowOutsideClick: false,
  allowEscapeKey: false,

  customClass: {
    popup: "swal-icon-system swal-icon-opening",
    title: "swal-icon-opening-title",
    htmlContainer: "swal-icon-opening-html",
  },

html: `
  <div class="icon-opening-minimal">

    <div class="icon-opening-minimal-indicator">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <p>Preparando edição do ícone</p>
    <small>Aguarde um instante</small>

  </div>
`,


  didOpen: () => {
    setTimeout(() => {
      Swal.close();
    }, 900);
  },
});


    // =========================================================
    // ESCOLHA DO ÍCONE
    // =========================================================

   
await Swal.fire({
  title: "",
  background: "#102333",
  width: "720px",
  padding: "0",
  showConfirmButton: false,
  showCloseButton: true,
  allowOutsideClick: true,
  allowEscapeKey: true,

  customClass: {
    popup: "swal-icon-selector",
    htmlContainer: "icon-selector-html",
    closeButton: "icon-selector-close",
  },

  html: `
    <div class="icon-selector">

      <header class="icon-selector-header">
        <div class="icon-selector-heading">
          <div class="icon-selector-heading-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="3"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <path d="m21 15-5-5L5 21"/>
              <path d="M16 3v6M13 6h6"/>
            </svg>
          </div>

          <div>
            <h3>Ícones dos veículos</h3>
            <p>Selecione a imagem que representará o veículo no mapa.</p>
          </div>
        </div>

        <div class="icon-selector-plate">
          <span>VEÍCULO</span>
          <strong>${String(item.placa || "Sem placa")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;")}</strong>
        </div>
      </header>

      <div class="icon-selector-body">
        <div class="icon-selector-section-title">
          <span>ESCOLHA UM ÍCONE</span>
          <span class="icon-selector-count">${icons.length} opções</span>
        </div>

        <div class="icon-selector-grid">
          ${icons.map((icon) => `
            <button
              type="button"
              class="icon-selector-item"
              data-icon="${String(icon.name).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}"
              data-src="${String(icon.src).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}"
              title="${String(icon.name).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}"
              aria-label="Selecionar ícone ${String(icon.name).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}"
            >
              <span class="icon-selector-image">
                <img src="${icon.src}" alt="" loading="lazy"/>
              </span>
              <span class="icon-selector-item-name">${String(icon.name)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")}</span>
            </button>
          `).join("")}
        </div>
      </div>

      <footer class="icon-selector-footer">
        <span>Selecione uma imagem para visualizar e confirmar.</span>
      </footer>

    </div>
  `,

  didOpen: () => {
    const cards = document.querySelectorAll(".icon-selector-item");

    cards.forEach((card) => {
      card.onclick = async () => {
        const iconName = card.dataset.icon;
        const iconSrc = card.dataset.src;

        const confirmIcon = await Swal.fire({
          title: "Confirmar alteração",
          background: "#102333",
          color: "#eaf2f7",
          width: "420px",
          padding: "26px",

          customClass: {
            popup: "swal-system icon-confirm-popup",
            title: "icon-confirm-title",
            confirmButton: "swal-system-confirm",
            cancelButton: "swal-system-cancel",
          },

          html: `
            <div class="icon-confirm-content">
              <div class="icon-confirm-preview">
                <img src="${iconSrc}" alt="Prévia do ícone selecionado"/>
              </div>

              <div class="icon-confirm-vehicle">
                <span>VEÍCULO SELECIONADO</span>
                <strong>${String(item.placa || "Sem placa")
                  .replace(/&/g, "&amp;")
                  .replace(/</g, "&lt;")
                  .replace(/>/g, "&gt;")
                  .replace(/"/g, "&quot;")
                  .replace(/'/g, "&#039;")}</strong>
              </div>

              <p class="icon-confirm-text">
                Deseja aplicar este ícone ao veículo?
              </p>
            </div>
          `,

          showCancelButton: true,
          confirmButtonText: "Confirmar alteração",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#287db5",
          cancelButtonColor: "#243b4b",
          reverseButtons: true,
          focusCancel: true,
        });

        if (!confirmIcon.isConfirmed) return;

        await Swal.fire({
          title: "Salvando alteração",
          background: "#102333",
          color: "#eaf2f7",
          width: "350px",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,

          customClass: {
            popup: "swal-system icon-loading-popup",
          },

          html: `
            <div class="icon-loading">
              <div class="icon-loading-spinner"></div>
              <p>Atualizando o ícone do veículo...</p>
            </div>
          `,

          didOpen: async () => {
            try {
              await api.put(
                `/equipamentos/${item.placa}/icone`,
                { icone: iconName },
                {
                  headers: {
                    typo: localStorage.getItem("id"),
                  },
                }
              );

              setMarcadores((prev) =>
                prev.map((m) =>
                  m.placa === item.placa
                    ? { ...m, icone: iconName }
                    : m
                )
              );

              Swal.close();

              await Swal.fire({
                title: "Ícone atualizado",
                text: "A alteração foi salva com sucesso.",
                background: "#102333",
                color: "#eaf2f7",
                icon: "success",
                timer: 1600,
                timerProgressBar: true,
                showConfirmButton: false,
                customClass: {
                  popup: "swal-system",
                },
              });
            } catch (error) {
              console.error("Erro ao alterar ícone:", error);
              Swal.close();

              await Swal.fire({
                title: "Não foi possível alterar",
                text: "O ícone não foi salvo. Tente novamente.",
                background: "#102333",
                color: "#eaf2f7",
                icon: "error",
                confirmButtonText: "Entendi",
                confirmButtonColor: "#287db5",
                customClass: {
                  popup: "swal-system",
                },
              });
            }
          },
        });
      };
    });
  },
});

  };
  // ================= JSX =================

return (
  <div className="icones-page">
    <div className="icones-card">

      {/* CABEÇALHO */}
      <header className="icones-header">
        <div className="icones-header-info">
          <div className="icones-header-symbol">
            <MdAddPhotoAlternate size={21} />
          </div>

          <div className="icones-header-text">
            <h5>Ícones</h5>
            <p>Gerenciamento dos ícones dos veículos</p>
          </div>
        </div>

        <button
          type="button"
          className="icones-close"
          onClick={() => navigate("/maps")}
          aria-label="Fechar"
          title="Voltar ao mapa"
        >
          ✕
        </button>
      </header>

      {/* CONTEÚDO */}
      <main className="icones-content">

        {/* BARRA DE FERRAMENTAS */}
        <section className="icones-toolbar">
          <div className="icones-search">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="7" />
              <path d="m16 16 4 4" />
            </svg>

            <input
              type="text"
              placeholder="Buscar por placa ou descrição..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Buscar por placa ou descrição"
            />

            {searchTerm && (
              <button
                type="button"
                className="icones-search-clear"
                onClick={() => setSearchTerm("")}
                aria-label="Limpar busca"
                title="Limpar busca"
              >
                ✕
              </button>
            )}
          </div>

          <div className="icones-toolbar-info">
            <span className="icones-status-dot" />
            <span>Gestão de ícones</span>
          </div>
        </section>
          <img src={logo} alt="Logo INOVA" className="logo" />

        {/* TABELA */}
        <section className="icones-table-section">
          <div className="icones-table-scroll">
            <table className="icones-table">
              <thead>
                <tr>
                  <th className="icones-col-placa">Placa</th>
                  <th>Descrição</th>
                  <th className="icones-col-acao">Ícone do veículo</th>
                </tr>
              </thead>

              <tbody>
                {marcadores.length > 0 ? (
                  marcadores.map((m) => (
                    <tr key={m.id}>
                      <td className="icones-placa">
                        <span>{m.placa || "—"}</span>
                      </td>

                      <td className="icones-descricao">
                        {m.obs || (
                          <span className="icones-sem-descricao">
                            Sem descrição
                          </span>
                        )}
                      </td>

                      <td className="icones-col-acao">
                        <div className="icones-row-actions">
                          <div className="icones-preview">
                            <img
                              src={`/icones/${m.icone}.png?v=${m.icone}`}
                              alt={`Ícone do veículo ${m.placa || ""}`}
                              loading="lazy"
                              onError={(e) => {
                                e.currentTarget.style.visibility = "hidden";
                              }}
                            />
                          </div>

                          <Tooltip title="Alterar ícone" placement="top">
                            <button
                              type="button"
                              className="icones-edit-button"
                              onClick={() => handleChangeIcon(m)}
                              aria-label={`Alterar ícone do veículo ${m.placa || ""}`}
                            >
                              <MdAddPhotoAlternate size={19} />
                              <span>Alterar</span>
                            </button>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>
                      <div className="icones-empty">
                        <div className="icones-empty-icon">
                          <MdAddPhotoAlternate size={27} />
                        </div>

                        <strong>Nenhum veículo encontrado</strong>

                        <span>
                          {searchTerm
                            ? "Tente pesquisar usando outra placa ou descrição."
                            : "Não há ícones para exibir nesta página."}
                        </span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>

        {/* RODAPÉ E PAGINAÇÃO */}
        <footer className="icones-footer">
          <div className="icones-footer-summary">
            <span className="icones-footer-label">
              Total de veículos
            </span>

            <strong>{totalItens}</strong>

            <span className="icones-footer-divider" />

            <span>
              {pages.length} {pages.length === 1 ? "página" : "páginas"}
            </span>
          </div>

          <div className="icones-pagination">
            <button
              type="button"
              className="icones-page-button"
              onClick={() => handlePagination(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Página anterior"
              title="Página anterior"
            >
              ‹
            </button>

            {getVisiblePages(currentPage, pages.length).map((p, i) => (
              p === "..." ? (
                <span key={`dots-${i}`} className="icones-page-dots">
                  …
                </span>
              ) : (
                <button
                  type="button"
                  key={p}
                  className={`icones-page-button ${
                    p === currentPage ? "active" : ""
                  }`}
                  onClick={() => handlePagination(p)}
                  aria-label={`Página ${p}`}
                  aria-current={p === currentPage ? "page" : undefined}
                >
                  {p}
                </button>
              )
            ))}

            <button
              type="button"
              className="icones-page-button"
              onClick={() => handlePagination(currentPage + 1)}
              disabled={currentPage === pages.length || pages.length === 0}
              aria-label="Próxima página"
              title="Próxima página"
            >
              ›
            </button>
          </div>

          <div className="icones-page-size">
            <label htmlFor="icones-limit">Exibir</label>

            <select
              id="icones-limit"
              value={limit}
              onChange={handleLimitChange}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={totalItens}>Todos</option>
            </select>

            <span>por página</span>
          </div>
        </footer>
      </main>

      <Preloader
        show={loading}
        text="Carregando ícones..."
        customClass="laoder-enfermeiro"
      />
    </div>
  </div>
);

}

export default Icones;